import { Type } from "@angular/core";
import {
    Cellstyle,
    HotAngularCell,
    HotCell,
    HotCellNumeric,
    HotCellText,
    IHotCellSettings,
    NumericCellChangeArg
} from "./cell";
import { Expander, HotCellExpander } from "./expander";
import { IHotCellAngularRenderedCellComponent } from "./hot-cell-angular-renderer.service";
import { HotIconButton } from "./hot-icon-button";

/* eslint-disable no-bitwise */
export class HotRow {
    readonly cells: HotCell[] = [];
    // Nedärvda rader för Handsontables nestedRows-plugin. Namnet är fast och styrs av Handsontable, inte konfigurerbart.
    __children?: HotRow[];
    constructor(readonly rowFlags = 0) { }
    add = <T extends HotCell>(name: string, cell: T): T => {
        // eslint-disable-next-line sonarjs/no-associative-arrays
        this.cells[name] = cell;
        this.cells.push(cell);
        return cell;
    };
    addAngularComponent = <T extends IHotCellAngularRenderedCellComponent>(
        name: string,
        ngComponent: Type<T>,
        ngComponentDataInit?: (instance: T) => void,
        flags?: Cellstyle,
        settings?: IHotCellSettings,
        onChange?: (change: NumericCellChangeArg) => void) => {
        this.add(name, HotAngularCell.create(ngComponent, ngComponentDataInit, this.rowFlags | flags, settings, onChange));
    };
    addEmpty = (name: string, flags?: Cellstyle, settings?: IHotCellSettings): HotCellText => this.add(name, new HotCellText(null, this.rowFlags | flags, settings));
    addText = (name: string, value: string, flags?: Cellstyle, settings?: IHotCellSettings): HotCellText => this.add(name, new HotCellText(value, this.rowFlags | flags, settings));
    addNumeric = (
        name: string,
        value: number,
        flags?: Cellstyle,
        onChange?: (arg: NumericCellChangeArg) => void,
        roundFn?: (val: number) => number): HotCellNumeric => this.add(name, new HotCellNumeric(value, this.rowFlags | flags, onChange, roundFn));
    addPercent = (name: string, value: number, flags?: Cellstyle, settings?: IHotCellSettings): HotCellText => {
        if (settings && settings.noZero && value === 0 || Number.isNaN(value)) {
            settings.zeroReplace = settings.zeroReplace ? settings.zeroReplace : "-";
            return this.add(name, new HotCellText(settings.zeroReplace, this.rowFlags | flags, settings));
        }
        return this.add(name, new HotCellText(`${value}%`, this.rowFlags | flags, settings));
    };
    addExpander = (expander: Expander, flags?: Cellstyle, settings?: IHotCellSettings): HotRow => {
        const expandersettings = expander.expanderSettings;
        if (!expandersettings) {
            throw new Error("För att använda en expander måste settings i hotDoc innehålla expanderSettings");
        }
        const cell = new HotCellExpander(expander, this.rowFlags | flags, settings);
        this.cells[expandersettings.name] = cell;
        this.cells.splice(expandersettings.col, 0, cell);
        return this;
    };
    addButton = (name: string, flags?: Cellstyle, settings?: IHotCellSettings) => {
        const cell = new HotIconButton(this.rowFlags | flags, settings);
        return this.add(name, cell);
    };
}
